import { render } from "./ProfileAccount.vue?vue&type=template&id=2a1e52e0&scoped=true"
import script from "./ProfileAccount.vue?vue&type=script&lang=js"
export * from "./ProfileAccount.vue?vue&type=script&lang=js"

import "./ProfileAccount.vue?vue&type=style&index=0&id=2a1e52e0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1e52e0"]])

export default __exports__